import AppForm from '../app-components/Form/AppForm';

Vue.component('document-group-form', {
    mixins: [AppForm],
    props: {
        'documentTypes': {
            //type: Array,
            required: true
        },
    }, 
    data: function() {
        return {
            form: {
               title: '',
               document_types: [] 
            }
        }
    },
    
    

});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/document-group/Form.js